import appConfig from "../utils/config";

function registerServiceWorker() {
    if (navigator.serviceWorker) {
        window.addEventListener('load', async () => {
            try {
                const registration = await navigator.serviceWorker.register('/service-worker.js');
                if (!appConfig.enableServiceWorkers) await registration.unregister();
            } catch (error) {
                console.log(error);
            }
        });
    }
};

export default registerServiceWorker;